import React, { useState } from 'react'
import { BiotrackUserOptionsModal } from './BiotrackUserOptionsModal'
import { LinkBiotrackUser } from './LinkBiotrackUser'
import { CreateBiotrackUser } from './CreateBiotrackUser'
import { BiotrackUserModalManagerProps } from './biotrackUserTypes'

export const BiotrackUserModalManager = ({
  open,
  onClose,
  employee,
  assignedShop,
  roles,
  dispatch,
}: BiotrackUserModalManagerProps) => {
  const [step, setStep] = useState<'options' | 'link' | 'create'>('options')
  const [userNotFound, setUserNotFound] = useState(false)

  const handleNextModal = (next: 'none' | 'options', errorType?: 'userNotFound') => {
    if (next === 'options') {
      if (errorType === 'userNotFound') {
        setUserNotFound(true)
      }
      setStep('options')
    } else {
      handleClose()
    }
  }

  const handleClose = () => {
    setStep('options')
    setUserNotFound(false)
    onClose()
  }

  if (!open) return null

  return (
    <>
      {step === 'options' && (
        <BiotrackUserOptionsModal
          open={true}
          onClose={handleClose}
          onGoBack={() => setStep('link')}
          onCreate={() => setStep('create')}
          modalTitle={userNotFound ? 'User not found!' : 'Biotrack User'}
          linkButtonText={userNotFound ? 'go back' : 'Link'}
          createButtonText="Create"
        />
      )}

      {step === 'link' && (
        <LinkBiotrackUser
          open={true}
          onClose={handleClose}
          onNextModal={handleNextModal}
          employee={employee}
          assignedShop={assignedShop}
          dispatch={dispatch}
        />
      )}

      {step === 'create' && (
        <CreateBiotrackUser
          open={true}
          onClose={handleClose}
          employee={employee}
          assignedShop={assignedShop}
          dispatch={dispatch}
          roles={roles}
        />
      )}
    </>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Employees/BiotrackUser/BiotrackUserModalManager.tsx